// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-ee92d4a2] .rm-legend {

    display: flex;

    list-style-type: none;

    flex-direction: column;

    gap: 4px
}
.dialogGraph[data-v-ee92d4a2] .rm-legend {

    display: grid;

    grid-template-columns: repeat(3, minmax(0, 1fr));

    gap: 8px
}
@media (min-width: 768px) {
.dialogGraph[data-v-ee92d4a2] .rm-legend {

        display: flex;

        gap: 4px
}
}
[data-v-ee92d4a2] .rm-legend-title {

    grid-column: span 3 / span 3;

    text-align: center;

    font-weight: 600;

    --tw-text-opacity: 1;

    color: rgb(23 35 68 / var(--tw-text-opacity, 1))
}
[data-v-ee92d4a2] .rm-legend__item {

    display: flex;

    cursor: pointer;

    -webkit-user-select: none;

       -moz-user-select: none;

            user-select: none;

    align-items: center;

    gap: 8px;

    font-size: 12px;

    line-height: 18px;

    --tw-text-opacity: 1;

    color: rgb(23 35 68 / var(--tw-text-opacity, 1))
}
[data-v-ee92d4a2] .rm-legend__item--hidden {

    text-decoration-line: line-through;

    opacity: 0.45
}
[data-v-ee92d4a2] .rm-legend__box {

    display: inline-block;

    height: 12px;

    width: 18px;

    flex-shrink: 0;

    border-radius: 3px
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
